<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'

const props = defineProps({
  items: {
    type: Array,
    default: null //[ { id, name } ]
  },
  modelValue: {
  }
});

const emit = defineEmits([ "update:modelValue", "change" ]);

const value = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
    emit('change', value);
  }
});

onMounted(() => {
});

onUnmounted(() => {
});

function setChoice(id) {
  value.value = id;
}
</script>

<template>
  <div class="tab-control" v-if="items?.length > 0">
    <button class="tab-button" :class="{ 'tab-active': value == item.id }" @click="setChoice(item.id)" v-for="(item, index) in items" v-key="'tab-item-' + index">{{ item.name }}</button>
  </div>
</template>

<style scoped>
.tab-control {
  @apply w-full border-b dark:border-gray-500;
}

.tab-control .tab-button {
  @apply px-5 py-3 dark:text-white;
}

.tab-control .tab-button.tab-active {
  border-bottom: 3px solid rgb(26 86 219);
}
</style>